// Global
import Vue                  from 'vue/dist/vue.min.js';
import VueResource          from 'vue-resource'
import VueRouter            from 'vue-router'
import store                from '../store'
import App                  from '../App.vue'
import Meta                 from 'vue-meta'
Vue.use(Meta)

// Builder Component
import BuildHome            from '../components/builder/BuildHome.vue'
import Builder              from '../components/builder/Builder.vue'
import CPU                  from '../components/builder/CPU'
import Compare              from '../components/builder/Compare.vue'
import Cart                 from '../components/builder/Cart.vue'

// Desktop
import Desktops             from '../Desktops.vue'

// User Profile
import ItemsController      from '../components/admin/ItemsController'
import Dashboard            from '../components/admin/Dashboard.vue'
import AccountHome          from '../components/admin/AccountHome.vue'
import AdminHome            from '../components/admin/AdminHome.vue'
import Register             from '../components/admin/Register.vue'
import RegisterSuccess      from '../components/admin/RegisterSuccess.vue'
import ResetPassword        from '../components/admin/ResetPassword.vue'
import Profile              from '../components/admin/Profile.vue'
import MyBuild              from '../components/admin/MyBuild.vue'
import YourOrders           from '../components/admin/YourOrders.vue'
import Items                from '../components/admin/Items.vue'
import AddPart              from '../components/admin/AddPart.vue'
import ScheduledJobs        from '../components/admin/ScheduledJobs.vue'
import Pipelines            from '../components/admin/Pipelines.vue'
import CandidateReview      from '../components/admin/CandidateReview.vue'
import CatalogHealth        from '../components/admin/CatalogHealth.vue'
import ContentManagement    from '../components/admin/ContentManagement.vue'
import BuildCoverage        from '../components/admin/BuildCoverage.vue'
import UserManagement       from '../components/admin/UserManagement.vue'
import Audience             from '../components/admin/Audience.vue'
import AiUsage              from '../components/admin/AiUsage.vue'
import AiPrompts            from '../components/admin/AiPrompts.vue'
import AffiliateSeoAnalytics from '../components/admin/AffiliateSeoAnalytics.vue'
import Subscribers          from '../components/admin/Subscribers.vue'
import Subscribe            from '../components/admin/Subscribe.vue'
import AppHome              from '../components/AppHome.vue'
import NotFound             from '../components/NotFound.vue'

// Project
import Project              from '../components/project/pages/Project.vue'


const builderUrl = '/builder/'

Vue.use(VueRouter)
Vue.use(VueResource)

export const routes = [{

    // Builder
        path: "/",
        name: "App",
        components: {
            default: App
        },
        children: [
            {
                // Root lands on the builder home.
                path: '',
                redirect: '/builder/home',
            },
            {
                name: 'AppHome',
                path: 'app',
                component: AppHome,
            },
            {
                path: 'builder',
                component: Builder,
                redirect: () => {
                    return store.getters.lastRoute
                },
                children: [{
                        path: builderUrl + "home",
                        name: 'Home',
                        component: BuildHome,
                    },
                    {
                        path: builderUrl + 'cpu',
                        name: 'cpu',
                        component: CPU,
                    },
                    {
                        path: builderUrl + 'motherboard',
                        name: 'motherboard',
                        component: CPU,
                    },
                    {
                        path: builderUrl + 'ram',
                        name: 'ram',
                        component: CPU
                    },
                    {
                        path: builderUrl + 'storage',
                        name: 'storage',
                        component: CPU
                    },
                    {
                        path: builderUrl + 'gpu',
                        name: 'gpu',
                        component: CPU
                    },
                    {
                        path: builderUrl + 'psu',
                        name: 'psu',
                        component: CPU
                    },
                    {
                        path: builderUrl + 'case',
                        name: 'case',
                        component: CPU
                    },
                ]
            },
            {
                path: builderUrl + "compare",
                name: "Compare",
                component: Compare,
            },
            {
                path: builderUrl + "cart",
                name: "Cart",
                component: Cart,
            }
        ]
    },
    // Docs
    {
        path: '/docs',
        name: "Documentation",
        component: Compare,
    },
    // Desktops
    {
        path: "/desktops",
        name: "Desktops",
        component: Desktops,
    },

    // User Profile
    {
        path: "/users/success",
        name: "RegisterSuccess",
        component: RegisterSuccess,
    },
    {
        path: "/users/register",
        name: "Register",
        component: Register,
    },
    {
        path: "/users/login",
        name: "Login",
        component: Register,
    },
    {
        // Public target for the password reset / setup email link:
        // ${FRONTEND_URL}/users/reset-password?token=...
        path: "/users/reset-password",
        name: "ResetPassword",
        component: ResetPassword,
    },
    {
        // Public subscriber signup + confirmation/unsubscribe redirect target:
        // /subscribe?subscription=confirmed|invalid|unsubscribed|unsubscribe-invalid
        path: "/subscribe",
        name: "Subscribe",
        component: Subscribe,
    },

    // User Dashboard
    {
        path: "/users/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
            requiresAuth: true
        },
        redirect: '/users/home',
        children: [
            {
                path: "/users/home",
                name: "Account Dashboard",
                component: AccountHome,
            },
            {
                path: "/users/admin",
                name: "Admin Dashboard",
                component: AdminHome,
                meta: { requiresAdmin: true },
            },
            {
                path: "/users/items-controller",
                name: "ItemsController",
                component: ItemsController,
                meta: { requiresAdmin: true },
                children: [
                    {
                        path: "/users/items-controller/items",
                        name: "Items",
                        component: Items,
                    },
                    {
                        path: "/users/items-controller/addpart",
                        name: "Add Part",
                        component: AddPart,
                    },
                    {
                        path: "/users/items-controller/editpart",
                        name: "Edit Part",
                        component: AddPart,
                    },
                ]
            },
            {
                path: "/users/profile",
                redirect: '/users/settings',
            },
            {
                path: "/users/settings",
                name: "Settings",
                component: Profile,
            },
            {
                path: "/users/mybuild",
                name: "My Build",
                component: MyBuild,
            },
            {
                path: "/users/orders",
                name: "Your Orders",
                component: YourOrders,
            },
            {
                path: "/users/pipelines",
                name: "Pipelines",
                component: Pipelines,
                meta: { requiresAdmin: true },
            },
            {
                path: "/users/jobs",
                name: "Scheduled Jobs",
                component: ScheduledJobs,
                meta: { requiresAdmin: true },
            },
            {
                path: "/users/candidates",
                name: "Onboard New Parts",
                component: CandidateReview,
                meta: { requiresAdmin: true },
            },
            {
                path: "/users/catalog-health",
                name: "Catalog Health",
                component: CatalogHealth,
                meta: { requiresAdmin: true },
            },
            {
                path: "/users/content",
                name: "Content Management",
                component: ContentManagement,
                meta: { requiresAdmin: true },
            },
            {
                path: "/users/build-coverage",
                name: "Build Coverage",
                component: BuildCoverage,
                meta: { requiresAdmin: true },
            },
            {
                path: "/users/users-management",
                name: "User Management",
                component: UserManagement,
                meta: { requiresAdmin: true },
            },
            {
                path: "/users/audience",
                name: "Audience",
                component: Audience,
                meta: { requiresAdmin: true },
            },
            {
                path: "/users/ai-usage",
                name: "AI Usage",
                component: AiUsage,
                meta: { requiresAdmin: true },
            },
            {
                path: "/users/ai-prompts",
                name: "AI Prompts",
                component: AiPrompts,
                meta: { requiresAdmin: true },
            },
            {
                path: "/users/affiliate-seo",
                name: "SEO Advisor",
                component: AffiliateSeoAnalytics,
                meta: { requiresAdmin: true },
            },
            {
                path: "/users/subscribers",
                name: "Subscribers",
                component: Subscribers,
                meta: { requiresAdmin: true },
            },
        ]

    },

    //Project
    {
        path: "/project",
        name: "Project",
        component: Project,
    },
    {
        path: "*",
        name: "Not Found",
        component: NotFound,
    },
];

export const router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'is-active',
    routes,
    scrollBehavior (to) {
        if (to.hash) {
          return {
            selector: to.hash,
            behavior: 'smooth',
          }
        }
      }
})

const userHasAdminAccess = () => {
    const user = store.getters.getUser || {}
    return user.is_admin == 1 || user.is_admin === true || user.is_god == 1 || user.is_god === true
}

router.beforeEach(async(to, from, next) => {
    console.log('Router beforeEach Started')

    // checking protected routes
    if (to.matched.some(record => record.meta.requiresAuth)) {
        console.log('The Route Is Protected')
        // this route requires auth, check if user is logged in
        // if not, redirect to login page.
        if (!localStorage.usertoken) {
            await store.dispatch('setLoggedOut')
            console.log('missing localstorage.usertoken, redirecting to /login')
            await store.dispatch('setLoggedIn', false)
            next({
                path: '/users/login',
                query: { redirect: to.fullPath }
            })
        } else {
            console.log('token found')
            // check if the token is still valid
            try {
                console.log('checking token validation....')
                await store.dispatch('validate')
                await store.dispatch('setLoggedIn')
                console.log('valid token')
                if (to.matched.some(record => record.meta.requiresAdmin) && !userHasAdminAccess()) {
                    next({ path: '/users/home' })
                }
                else {
                    // user is logged in with a valid token
                    next()
                }
            } catch (e) {
                await store.dispatch('setLoggedOut')
                console.log('token is invalid, deleting token from state')
                    // the token is invalid so we will have the user login again
                    // clear the token and user info
                    // store.commit('DELETE_USER')
                    // console.log('user deleted, redirecting to /corp/login')
                next({
                    path: '/',
                    query: { redirect: to.fullPath }
                })
            }
        }
    }
    else {
        if(store.getters.loggedIn == 'true' && store.getters.getUser == null){
            await store.dispatch('validate')
        }
    console.log('the route is not protected')
    next()
    }
})
